// services/administrativo/dashService.js
import { fetchData } from '../Api';

export const buscarDashboard = async (params = {}) => {
  return await fetchData('/Dash', params);
};
